/**
* @brandOverride URBNWeb
*/
import cartSagas from '../../../core/js/sagas/cartSagas';
import mislSagas from '../../../core/js/sagas/mislSagas';
import userSagas from '../../../core/js/sagas/userSagas';
import utagSagas from '../../../core/js/sagas/utagSagas';
import groundhogSagas from '../../../core/js/sagas/groundhogSagas';
import categoryInitialSagas from '../sagas/categoryInitialSagas';
import categoryFacetSagas from '../sagas/categoryFacetSagas';
import categoryNewSagas from '../sagas/categoryNewSagas';
import categoryPaginateSagas from '../sagas/categoryPaginateSagas';
import categorySortSagas from '../sagas/categorySortSagas';
import registrySagas from '../../../registry/js/sagas/registrySagas';
import { getSaytSagas } from '../../../core/js/sagas/saytSagas';

const categoryStartingSagas = [
    ...cartSagas,
    ...mislSagas,
    ...getSaytSagas(),
    ...userSagas,
    ...utagSagas,
    ...categoryInitialSagas,
    ...categoryFacetSagas,
    ...categoryNewSagas,
    ...categoryPaginateSagas,
    ...categorySortSagas,
    ...registrySagas,
    ...groundhogSagas
];

export default categoryStartingSagas;
